<div class="cookie-banner">
	<div class="row">
		<div class="col-12 cookie-banner__col">
			<div class="cookie-banner__text">
				<span class="cookie-banner__uses" i18n="Cookie Banner Text@@cookie.banner.message">
					This website uses cookies.
				</span>

				<span i18n="Cookie Banner Sub Text@@cookie.banner.sub.message">
					You have to agree to our cookie statement for optimal use.
				</span>

				<span>
					<a [href]="cookieStatementUrl"
					   i18n="Cookie Banner Read more Text@@cookie.banner.link.message"
					   target="_blank">
						Read more
					</a>
				</span>
			</div>

			<div class="button-bar button-bar--right button-bar--mobile-block">
				<button (click)="applicationService.openCustomizeCookiePopup()"
				        class="button button--secondary theme-btn-secondary-outline"
				        i18n="Customize Cookies@@cookie.banner.button.customize.message">
					Customize Cookies
				</button>

				<button (click)="acceptAllCookies()"
				        class="button button--secondary theme-btn-secondary-outline"
				        i18n="Accept All Cookies@@cookie.banner.button.accept.all.message">
					Accept All Cookies
				</button>
			</div>
		</div>
	</div>
</div>
